import { FormattedHTMLMessage, injectIntl } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";

export const EBTCardNumber = ({
  value,
  isErrored,
  onChange,
  intl,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const isFieldHidden = getFieldConfigByFieldId("ebtCardNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="ebtCardNumber"
      value={value}
      onChange={onChange}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({
          id: "ebtCardNumberPlaceholder",
          defaultMessage: "EBT card Number",
        })
      }
      label={<FormattedHTMLMessage id="ebtCardNumber" defaultMessage="EBT card Number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidEBTCardNumber"
            defaultMessage="Invalid EBT Card Number"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};

export const EBTCardNumberComponent = injectIntl(EBTCardNumber);
